var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { buildSelfDescribingEvent } from "./emitter/index.js";
import { tracker } from "./tracker/index.js";
import { AxiosEmitter } from "./emitter/axios.js";
import { AllEventIdentities, EVENT_SCHEMA_TO_IDENTITIES, } from "./event/index.js";
export class Connector {
    constructor(trackerIdToEndpointConfig) {
        this.trackers = {};
        const _a = Object.assign({}, trackerIdToEndpointConfig), { appId, trackerIds } = _a, emitterConfig = __rest(_a, ["appId", "trackerIds"]);
        this.appId = appId;
        for (const trackerId of trackerIds) {
            const e = new AxiosEmitter(Object.assign(Object.assign({}, emitterConfig), { endpoint: "/" + trackerId }));
            const encodeBase64 = true;
            this.trackers[trackerId] = tracker([e], trackerId, this.appId, encodeBase64);
        }
        this.track = Object.entries(EVENT_SCHEMA_TO_IDENTITIES).reduce((acc, [schema, identity]) => {
            return Object.assign(Object.assign({}, acc), this.genEventTrackers(identity, schema));
        }, {});
    }
    forceFlush() {
        for (const trackerId of Object.keys(this.trackers)) {
            this.trackers[trackerId].flush();
        }
    }
    genEventTrackers(identity, schemaUrl) {
        const trackerNames = Object.keys(identity);
        const reducer = (acc, key) => {
            acc[key] = this.buildTrackEvent(schemaUrl, key);
            return acc;
        };
        return trackerNames.reduce(reducer, {});
    }
    buildTrackEvent(schemaUrl, typeName) {
        return (data, trackerIds) => {
            const _a = Object.assign(Object.assign(Object.assign({}, data), AllEventIdentities[typeName]), { busReceivedTs: "", appId: this.appId }), { __typename } = _a, payload = __rest(_a, ["__typename"]);
            for (const trackerId of trackerIds) {
                if (!this.trackers[trackerId]) {
                    throw new Error(`${__typename} failed: ${trackerId} tracker has not been configured`);
                }
                this.trackers[trackerId].track(buildSelfDescribingEvent({
                    event: {
                        schema: schemaUrl,
                        data: payload,
                    },
                }));
            }
        };
    }
}
